// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Dobrev IT Ltd

// APP_VERSION is the build version baked into this bundle at build time (the Makefile passes
// VITE_APP_VERSION=$(VERSION) to `vite build`; it shares the homeserver's VERSION). We compare it
// to the version /client/v1/config reports so a redeploy can prompt the running client to update.
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || "dev";
